<template>
    <div>
        <!-- <a
            rel="noopener"
            :href="lang.magazine.link"
            target="_blank"
            class="btn"
        ><img :alt="lang.magazine.link" src="/img/icons/ico_sfoglia.png" width="20" height="20">{{ lang.magazine.button }}</a> -->

        <span
            @click="openLoginModal"
            class="btn"
        >
           {{ lang.magazine.button }}
        </span>

        <modal
            name="magazine-modal"
            ref="magazine-modal"
            extra-class="full-modal animated fadeInUpBig"
        >
            <template slot="body" slot-scope="props">
                <div ref="rrrr"></div>
                <flipbook
                    ref="flipbook"
                    v-slot="flipbook"
                    class="flipbook"
                    :pages="['', ...pages]"
                >   

                <div class="ico-flip">
                    <button @click="flipbook.flipLeft"><masked-image src="/img/icons/ico_arrow-left.svg"></masked-image></button>
                    <button @click="flipbook.flipRight"><masked-image src="/img/icons/ico_arrow-right.svg"></masked-image></button>

                    <button @click="flipbook.zoomIn"><masked-image src="/img/icons/ico_zoom-in.svg"></masked-image></button>
                    <button @click="flipbook.zoomOut"><masked-image src="/img/icons/ico_zoom-out.svg"></masked-image></button>

                    {{ flipbook.page }} / {{ flipbook.numPages }}
                </div>

                </flipbook>
            </template>
        </modal>
    </div>
</template>

<script>
import Flipbook from 'flipbook-vue'
import Modal from './Modal'

export default {
    components: {
        Flipbook,
        'modal': Modal,
    },

    props: {
        pages: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            showMagazine: false
        }
    },

    mounted() {
        window.addEventListener('keydown', ev => {
            let flipbook = this.$refs.flipbook

            if (ev.keyCode === 37 && flipbook.canFlipLeft) {
                flipbook.flipLeft()
            }
            else if (ev.keyCode === 39 && flipbook.canFlipRight) {
                flipbook.flipRight()
            }
        })
    },

    computed: {
        lang() {
            return this.$root.lang.home
        },
    },

    methods: {
        openLoginModal() {
            window.events.$emit('showModal', { name: 'magazine-modal' })
        }
    }

}
</script>

<style>
.flipbook-wrapper {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #333;
    color: #ccc;
    overflow: hidden;
}
.action-bar {
    width: 100%;
    height: 30px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.flipbook {
    width: 90vw;
    height: 90vh;
}

.flipbook .viewport {
    width: 90vw;
    height: calc(100vh - 50px - 40px);
}

.flipbook .bounding-box {
    box-shadow: 0 0 20px #000;
}

.full-modal .modal-dialog {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
    top: 0;
}
</style>